import {ErrorField} from "./data";
import {Action} from "redux";

export type QueryFormAction = SetTitleAction
	| SetFailureAction
	| SetSubmittingAction

type SetTitleAction = {
	type: 'set title'
	title: string
}

type SetFailureAction = {
	type: 'set failure'
	errorFields: ErrorField[]
}

type SetSubmittingAction = {
	type: 'set submitting'
	submitting: boolean
}

export type QueryFormActionWrapper = {
	type: 'query form action'
	action: QueryFormAction
}

export const isQueryFormAction = (a: Action): a is QueryFormActionWrapper => a.type == 'query form action'



// WEBPACK FOOTER //
// ./src/contacts/saved-queries/query-form/actions.ts